<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    max-width="290px"
    min-width="290px"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        autocomplete="off"
        :data-cy="dataCy"
        :disabled="computedDisabled"
        :label="label"
        v-model="computedDate"
        append-icon="mdi-calendar"
        outlined
        :dense="dense"
        :rules="rules"
        class="vuetify"
        :readonly="computedReadOnly"
        v-on="computedReadOnly ? on: null"
        v-bind="attrs"
        @keydown="onlyNumber"
        :error="msgErrors && msgErrors.length > 0 ? true : false"
        :error-messages="msgErrors.length  ? msgErrors : errorsMessages"
        :hide-details="computedHide"
        @click:append="menu=true"
        @change="chgValue"
        @blur="brValue"
        @input="emtInput"
        clearable
      ></v-text-field>
    </template>
    <v-date-picker
      locale="pt-br"
      :max="maxDate ? maxDate.slice(0, 10) : undefined"
      v-model="computedDateInternal"
      no-title
      @change="$emit('updateDate', computedDateInternal)"
      @input="saved"
    ></v-date-picker>
  </v-menu>
</template>

<script>
export default {
  name: 'DatePicker',
  props:{
    binding: String,
    label: String,
    messageError: Array,
    hide: [Boolean, String], // "auto": só reserva espaço quando há mensagem de erro
    readOnly: Boolean,
    disabled: Boolean,
    dataCy: String,
    rules: Array,
    maxDate: String, // YYYY-MM-DD: o calendário não passa dela e a data digitada acima dela vira erro (dateErrors)
    errorsMessages:String,
    dense: Boolean // filtros: mesma altura das outras caixas
  },
  data () {
    return {
      menu: false,
      msg_errors: [],
    }
  },

  methods: {
    checkInvalidDate(value) {
      let regex = /^([0-2][0-9]|(3)[0-1])(\/)(((0)[0-9])|((1)[0-2]))(\/)\d{4}$/
      const aboveMax = !!(value && this.maxDate && this.formatISO(value) > this.maxDate.slice(0, 10));
      if (value && !regex.test(value)) {
        this.msg_errors.push('Data inválida')
      } else if (aboveMax) {
        this.msg_errors = ['Data maior que a permitida'];
      } else { this.msg_errors = []}
      if (this.maxDate) this.$emit('dateErrors', aboveMax);
    },
    brValue(ev) {
      this.checkInvalidDate(ev.target.value)
    },
    chgValue(ev) {
      this.checkInvalidDate(ev)
      this.$emit('change',ev)
    },
    emtInput(date) {
      if(date && date.replace(/[^0-9]/gim, '').length > 7) {
        this.$emit('typing', date);
        this.brValue({target:{value:date}});
      }
    },
    onlyNumber (event) {
      const n = '0123456789/'
      const k = event.key

      if (n.includes(k) || k == 'Backspace' || k == 'Delete' || k == 'Tab' || k == 'ArrowLeft' || k == 'ArrowRight') {
        return true
      } else {
        return event.preventDefault();
      }

    },

    formatDate (date) {
      if (!date) return null;

      const [year, month, day] = date.split('-')

      return `${day}/${month}/${year}`
    },

    formatISO(date) {
      if (!date) return null;
      let day = '';
      let month = '';
      let year = '';
      if (date.includes('/')) {
        [day, month, year] = date.split('/')
      } else {
        day = date.substring(0,2);
        month = date.substring(2,4);
        year = date.substring(4,8);
      }

      return `${year}-${month}-${day}`

    },
    saved (value) {
      let myDate = value;
      this.menu = false;
      if (this.maxDate) {
        this.msg_errors = [];
        this.$emit('dateErrors', false);
      }
      this.$emit('update:binding', myDate);
      this.$emit('change', true);
    },
  },
  computed: {
    computedDate: {
      get: function() {
        return this.formatDate(this.computedDateInternal);
      },
      set: function(newValue) {
        if (!newValue) this.$emit('update:binding', null)
        if(newValue) newValue = newValue.replace(/[^0-9]/gim, '');
        if (newValue && ( (newValue.includes('/') && newValue.length == 10) || (!newValue.includes('/') && newValue.length == 8) )) {
          this.checkInvalidDate(newValue)
          this.computedDateInternal = this.formatISO(newValue);
        } else {
          this.checkInvalidDate(newValue)
        }
      }
    },
    computedDateInternal: {
      get: function() {
        return this.binding;
      },
      set: function(newValue) {
        this.$emit('update:binding', newValue);
        this.$emit('change', true);
      }
    },

    computedReadOnly: function () {
      return this.readOnly || this.readOnly == undefined  ? true : false;
    },

    computedHide: function () {
      if(this.hide === "auto") return "auto";
      return this.hide ? true : false;
    },

    computedDisabled: function() {
      return this.disabled ? true : false;
    },

    msgErrors() {
      return this.messageError?.length ? [...this.messageError, ...this.msg_errors] : [...this.msg_errors]
    }
  },

  mounted () {

  }
};
</script>

<style></style>